module.exports = __webpack_public_path__ + "static/media/AngryBagel.d4115509.svg";